import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm, FormItem, Radio } from 'formik-antd';
import {
  AddressAutoCompleteForm,
  useAddressData,
} from 'components/address-auto-complete';
import StagePropTypes from './prop-types';

import { DB_PREFIX } from './constants';

const Form = ({ values, setFieldValue, children }) => {
  const { fromOrg, address } = values[DB_PREFIX];
  const { postCode } = address || {};
  const prefix = `${DB_PREFIX}.address.`;

  const handleAddressData = useAddressData({
    setFieldValue,
    prefix,
  });

  return (
    <FormikForm layout="vertical">
      <FormItem
        label="Is the office address the same as the organisation?"
        name={`${prefix}fromOrg`}
      >
        <Radio.Group
          defaultValue=""
          name={`${DB_PREFIX}.fromOrg`}
          onChange={({ target: { value } }) => {
            setFieldValue(`${DB_PREFIX}.address`, value ? null : {});
          }}
        >
          <Radio.Button value>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </FormItem>
      {fromOrg === false ? (
        <AddressAutoCompleteForm
          prefix={prefix}
          input={postCode}
          setAddressData={handleAddressData}
        />
      ) : null}

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  children: PropTypes.node,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

Form.defaultProps = {
  children: null,
};

export default Form;
